module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/bus-route-list/bus-route-list.component.scss
// module id = 1192
// module chunks = 0